import { Boundaries } from "@frontend/components/site/boundaries";
import { ClosingCta } from "@frontend/components/site/closing-cta";
import { Faq, FAQS } from "@frontend/components/site/faq";
import { Features } from "@frontend/components/site/features";
import { FactStrip, Hero } from "@frontend/components/site/hero";
import { HowItWorks } from "@frontend/components/site/how-it-works";
import { branding } from "@creators/backend/lib/config";
import { HOME_DESCRIPTION, Seo } from "@frontend/lib/seo";
import { useViewer } from "@frontend/lib/viewer";

export function HomePage() {
  const { viewer } = useViewer();
  const signedIn = Boolean(viewer && !viewer.isAdmin);
  const host = branding.domain;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };

  const siteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: branding.name,
    url: `https://${branding.domain}/`,
    description: HOME_DESCRIPTION,
  };

  return (
    <main className="mkt">
      <Seo
        title={`${branding.name} — creator collaborations, without the chase`}
        description={HOME_DESCRIPTION}
        path="/"
        jsonLd={[siteSchema, faqSchema]}
      />
      <Hero host={host} signedIn={signedIn} />
      <FactStrip />
      <HowItWorks host={host} />
      <Features />
      <Boundaries />
      <Faq />
      <ClosingCta signedIn={signedIn} />
    </main>
  );
}
